import { render } from "./DraggableTableMob.vue?vue&type=template&id=6db78aea&scoped=true"
import script from "./DraggableTableMob.vue?vue&type=script&lang=js"
export * from "./DraggableTableMob.vue?vue&type=script&lang=js"

import "./DraggableTableMob.vue?vue&type=style&index=0&id=6db78aea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db78aea"]])

export default __exports__